import { pathOr } from 'ramda';

import { Box, VStack, Text } from '@frontend/components';

import PartCell from './PartCell';

const ComponentMatchList = ({ partResult }) => {
  const { childParts } = partResult;
  if (!childParts || childParts.length === 0) {
    return <Text color="feature.placeholder">---</Text>;
  }

  return (
    <Box minHeight={20} verticalAlign="top">
      <VStack alignItems="start">
        {(childParts || []).map((childPartResult, idx) => {
          const primaryFile = pathOr(
            [],
            ['data', 'partFiles'],
            childPartResult,
          ).find((partFile) => partFile.isPrimaryFile == true);
          const { uuid: partFileUuid, filename, containsVirus } = primaryFile;
          return (
            <PartCell
              key={idx}
              partResult={childPartResult}
              primaryFileUuid={partFileUuid}
              filename={filename}
              containsVirus={containsVirus}
              href={childPartResult.path}
            />
          );
        })}
      </VStack>
    </Box>
  );
};

export default ComponentMatchList;
